<template>
  <div class="step_bar">
    <div class="step_container">
      <div class="step disable">
        <div class="step_icon">
          <div class="step_mask"></div>
        </div>
        購物車
      </div>
      <div class="step disable">
        <div class="step_icon">
          <div class="step_mask"></div>
        </div>
        填寫資料
      </div>
      <div class="step disable">
        <div class="step_icon">
          <div class="step_mask"></div>
        </div>
        付款
      </div>
      <div class="step disable">
        <div class="step_icon">
          <div class="step_mask"></div>
        </div>
        完成訂單
      </div>
    </div>
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped bg-info progress-bar-animated"
        role="progressbar"
        :aria-valuenow="percentage"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="'width: ' + percentage"
      ></div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";

export default {
  props: {
    active: {
      type: Number,
      required: true,
    },
    percentage: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    onMounted(() => {
      for (let i = 1; i <= props.active; i++) {
        $("div.step:nth-child(" + i + ")").removeClass("disable");
      }
    });
  },
};
</script>

<style scoped>
.step_bar {
  position: relative;
  margin: 0 auto;
  width: 40%;
  max-width: 480px;
}

.progress {
  display: -ms-flexbox;
  display: flex;
  height: 5px;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
  position: absolute;
  top: 17px;
  margin: 0 2%;
  width: 96%;
  z-index: 1;
}

.bg-info {
  background-color: #00d7e1 !important;
}

.progress-bar-striped {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.3) 30%,
    transparent 30%,
    transparent 50%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0.3) 70%,
    transparent 70%,
    transparent
  );
  background-size: 1rem 1rem;
}

.step_container {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  z-index: 2;
}

.step_container .disable .step_icon {
  background: #e9ecef;
}

.step_container .disable {
  color: #CCC;
}

.step {
  position: relative;
  width: auto;
  text-align: center;
  color: #19B0C1;
  font-size: 13px;
}

.step_icon {
  position: relative;
  margin: 0 auto 2px auto;
  width: 36px;
  height: 36px;
  background: #00d7e1;
  border-radius: 40px;
}

.step_mask {
  position: absolute;
  top: 13px;
  bottom: 13px;
  left: 13px;
  right: 13px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 10px;
}

@media (max-width: 769px) {
  .step_bar {
    width: 50%;
    max-width: none;
  }
}

@media (max-width: 576px) {
  .step_bar {
    width: 80%;
    max-width: none;
  }
}
</style>
